import React, { useEffect, useState } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const containerStyle = {
  minWidth: "400px",
  width: "100%",
  minHeight: "500px",
  height: "100%",
};

interface OffenseLocationMapProps {
  incidentCoords?: {
    lat: number;
    lng: number;
  };
}

const libraries = ["geometry"] as any[];

const OffenseLocationMap = ({ incidentCoords }: OffenseLocationMapProps) => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
    libraries,
    language: "he",
  });

  const onLoad = React.useCallback(function callback(map: google.maps.Map) {
    map.setZoom(16);
  }, []);

  const [markerLocation, setMarkerLocation] = useState({
    lat: incidentCoords?.lat,
    lng: incidentCoords?.lng,
  });

  useEffect(() => {
    setMarkerLocation({
      lat: incidentCoords?.lat,
      lng: incidentCoords?.lng,
    });
  }, [incidentCoords]);

  return isLoaded && !!markerLocation?.lat && !!markerLocation.lng ? (
    // D-10: the map is geographic — it keeps its natural (LTR) orientation in
    // both languages; only the surrounding UI/labels translate and flip.
    <div dir="ltr" style={{ width: "100%", height: "100%" }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={markerLocation}
        zoom={16}
        onLoad={onLoad}
      >
        <Marker position={markerLocation} />
      </GoogleMap>
    </div>
  ) : null;
};

export default React.memo(OffenseLocationMap);
